// ----------------------------------------------------------------------

const account = {
  displayName: 'GigBig Admin',
  email: 'info@teamlans.com',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
